// extracted by mini-css-extract-plugin
export default {"progress":"LoadingScreen__progress__jIUbC","label":"LoadingScreen__label__vzjhL","track":"LoadingScreen__track__ig02b","fill":"LoadingScreen__fill__KiQmh"};